//= require "../node_modules/jquery/dist/jquery.js"
//= require "shards/htmlclass/_htmlclass.js"
//= require "shards/htmlclass/useragent-html-classes.js"
//= require "shards/masked_input/_masked_input.js"
//= require "shards/scroll/simplebar.min.js"
//= require "../node_modules/swiper/js/swiper.js"
//= require "js/application_forms.js"
//= require "js/accounting.min.js"
var zaemCardsSlider;
var accuProgramSwiper;
var accuProgramSwiperMulty;
var progCardsSlider;
var programsFilterSlider;

console.log(Math.random());
(function ($) {
  "use strict";
  // Local variables
  var resizeTimer,
    // $body = $('body'),
    $window = $(window),
    htmlbody = $("html, body"),
    windowWidth = $window.innerWidth();

  var widthExtremeBreakpoint = 1260,
    widthWideBreakpoint = 992,
    widthAverageBreakpoint = 768,
    widthNarrowBreakpoint = 480;
  const a = "site is operational";
  console.log(a);
  $.mask.definitions["~"] = "[9]";
  $(".maskedphone").mask("+7 (~99) 999-99-99", { autoclear: false });
  $(".maskedbirtdate").mask("99.99.9999");

  /** Open/Close */
  /*
     var ftlItemTitle = $('.ftlm-item__jshook svg');
     ftlItemTitle.on('click', function () {
     var ftlm = $(this).parent();
     if ($(ftlm).hasClass('ftl-title-opened')) {
     $(ftlm).removeClass('ftl-title-opened');
     $(ftlm).siblings('.ftlm-item__menuitems').slideUp('fast');
     } else {
     $(ftlm).addClass('ftl-title-opened');
     $(ftlm).siblings('.ftlm-item__menuitems').slideDown('fast');
     }
     });
     */
  var ftlItemTitle = $(".ftlm-item");
  ftlItemTitle.on("click", function () {
    var ftlm = $(this).find(".ftlm-item__jshook");
    if ($(ftlm).hasClass("ftl-title-opened")) {
      $(ftlm).removeClass("ftl-title-opened");
      $(ftlm).siblings(".ftlm-item__menuitems").slideUp("fast");
    } else {
      $(ftlm).addClass("ftl-title-opened");
      $(ftlm).siblings(".ftlm-item__menuitems").slideDown("fast");
    }
  });
  /** Scroll to top */
  var sttbtn = $("#scrolltop");

  sttbtn.on("click", function (e) {
    e.preventDefault();
    htmlbody.animate({ scrollTop: 0 }, "300");
  });
  // var lifestorybtn = $('#lifestory-btn');

  // lifestorybtn.on('click', function (e) {
  //     e.preventDefault();
  //     // htmlbody.animate({ scrollTop: 0 }, '300');
  //     $("html, body").animate({ scrollTop: $('#lifestory').height() + 200 }, 300);
  // });
  $("#lifestory-btn").click(function (event) {
    event.preventDefault();
    $("html, body").animate(
      { scrollTop: $($(this).attr("href")).offset().top },
      500
    );
  });

  /** Modal */
  /*** Modal close button */
  var modalCloseBtn = $(".ui-modal__close"),
    // uiModalDoclist = $('.ui-modal__doclist'),
    modalGeneralDocListTrigger = $(
      "#modalGeneralDocList, #modalGeneralDocListMob, .faq__mob-menu"
    ),
    modalCloseBG = $(".ui-modal__bg"),
    modalDocList01 = $("#modalDocList01"),
    modalGeneralDocListMobile = $("#generalDocListMobile"),
    modalGeneralDocList = $("#generalDocList"),
    uiModal = $(".ui-modal");

  function checkModalScroll() {
    if (uiModal.scrollTop() > 15) {
      modalCloseBtn.addClass("round-button");
    } else {
      modalCloseBtn.removeClass("round-button");
    }
  }

  uiModal.on("scroll", function () {
    checkModalScroll();
  });

  checkModalScroll();
  modalCloseBtn.on("click", closeModal);

  modalCloseBG.on("click", closeModal);

  modalGeneralDocListTrigger.on("click", openModal);

  function closeModal() {
    modalGeneralDocList.find(".ui-modal__content").addClass("ui-modal-closed");
    modalGeneralDocListMobile
      .find(".ui-modal__content")
      .addClass("ui-modal-closed");
    $("video").trigger("pause");
    setTimeout(
      function () {
        modalGeneralDocList.hide();
        modalGeneralDocListMobile.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  }

  function openModal(e) {
    e.preventDefault();
    modalGeneralDocList
      .find(".ui-modal__content")
      .removeClass("ui-modal-closed");
    modalGeneralDocListMobile
      .find(".ui-modal__content")
      .removeClass("ui-modal-closed");
    htmlbody.addClass("scrollOff");
    if (windowWidth < widthWideBreakpoint) {
      modalGeneralDocListMobile.show();
    } else {
      modalGeneralDocList.show();
    }
  }

  // Video play
  var videoProfit = $(".video"),
    videoProfitPoster = $(".video-poster"),
    videoProfitIframe = $(".video-iframe"),
    videoProfitTag = $(".video-tag"),
    videoProfitBtn = $("#playBtn");

  videoProfitBtn.on("click", function () {
    videoProfit.toggleClass("video-poster");
    videoProfitTag.trigger("play");
    //videoProfitIframe[0].src += "?autoplay=1";
  });

  // Fixed scroll menu
  var floating = $(".floating");

  $(window).scroll(function () {
    var scrolled = $(window).scrollTop();

    if (scrolled >= 434) {
      floating.slideDown(400);
    } else {
      floating.slideUp(400);
    }
  });

  // Second menu
  var secondMenuLinks = [
    $(".header__links li:eq(0)"),
    $(".header__links li:eq(1)"),
  ];
  for (var i = 0; i < secondMenuLinks.length; i++) {
    secondMenuLinks[i].mouseover(function () {
      let overed = true;
      $(".menu-second:eq(" + i + ")").css({ display: "block" });
    });
    secondMenuLinks[i].bind("mouseout", function (event) {
      if (event.relatedTarget.style.display == "block") {
        $(".menu-second:eq(" + i + ")").css({ display: "block" });
      } else {
        $(".menu-second:eq(" + i + ")").css({ display: "none" });
      }
    });
    $(".menu-second:eq(" + i + ")").mouseleave(function () {
      $(".menu-second:eq(" + i + ")").css({ display: "none" });
    });
  }

  /** Menu mobile */
  var menu = $("#menu"),
    menuIcon = $("#nav-icon"),
    mobileMenuDarkBG = $("#mobile-menu-dark-bg"),
    menuToggle = $("#menuToggle, #mobile-menu-dark-bg");

  function navClose() {
    console.log("navClose");
    htmlbody.removeClass("scrollOff");
    mobileMenuDarkBG.fadeOut();
    menuToggle.removeClass("openednav");
    menuIcon.removeClass("open");
    menu.removeClass("mobile-menu-opened");
  }

  function navOpen() {
    console.log("navOpen");
    htmlbody.addClass("scrollOff");
    mobileMenuDarkBG.fadeIn();
    menuToggle.addClass("openednav");
    menuIcon.addClass("open");
    menu.addClass("mobile-menu-opened");
  }

  menuToggle.on("click", function () {
    console.log("menuToggle");
    if ($(this).hasClass("openednav")) {
      navClose();
    } else {
      navOpen();
    }
  });

  /*$(window).on('scroll', function () {
     navClose();
     });*/

  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      navClose();
    }
  });

  /** Accordion */
  var accordionHead = $(".accordion-list__head"),
    accordionList = $(".accordion-list"),
    sidebarTriggers = $(".accordion-list__position");

  function sidebarTriggerFunc(el) {
    var mainPanelId = el.data("main-panel-id");

    sidebarTriggers.removeClass("accordion-list__position_active");
    el.addClass("accordion-list__position_active");

    $(".accordion__main").hide();
    $(".accordion__main-active").removeClass("accordion__main-active");

    if (screen.width > widthExtremeBreakpoint) {
      $(".faq .accordion-list:first-child").addClass("accordion__sidebar_pc");
      $(`.accordion__main[data-main-panel="${mainPanelId}"]`)
        .css({ display: "block" })
        .addClass("accordion__main-active");

      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(".accordion__main-active").offset().top - 20,
        },
        400
      );
    } else {
      modalGeneralDocListMobile
        .find(".ui-modal__content")
        .addClass("ui-modal-closed");
      setTimeout(function () {
        modalGeneralDocListMobile.hide();
        htmlbody.removeClass("scrollOff");
      }, 400);
      modalGeneralDocList
        .find(".ui-modal__content")
        .addClass("ui-modal-closed");
      setTimeout(function () {
        modalGeneralDocList.hide();
        htmlbody.removeClass("scrollOff");
      }, 400);
      $(".mob-menu__title").text($(this).text());
      $(`.accordion__main[data-main-panel="${mainPanelId}"]`)
        .css({ display: "block" })
        .addClass("accordion__main-active");

      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(".accordion__main-active").offset().top - 70,
        },
        400
      );
    }
  }

  sidebarTriggers.on("click", function () {
    sidebarTriggerFunc($(this));
  });

  function openActiveAsk() {
    if (accordionList.length) {
      // Ищем элемент с активным вопросом (активность помечает бэк)
      var openEl = $(".alh-opened");
      if (openEl.length) {
        // Получаем id активного вопроса
        var mainPanel = openEl.closest(".accordion-list").data("main-panel");
        // Находим аккордеон, который является логическим родителем, но находится в другом блоке
        var firstParent = $(
          '.accordion-list__position[data-main-panel-id="' + mainPanel + '"]'
        ).last();
        // Вызываем функцию, которая открывает ответ на вопрос
        sidebarTriggerFunc(firstParent);
        // Находим и раскрываем все родительские аккордеоны
        var parentsBody = firstParent.parents(".accordion-list__info");
        var parentsHead = parentsBody.siblings(".accordion-list__head");
        parentsBody.css("display", "block");
        parentsHead.addClass("alh-opened");
        parentsHead.find(".accordion-list__head-expand span").text("-");
      }
    }
  }
  $(document).ready(function () {
    openActiveAsk();
  });

  accordionHead.on("click", function () {
    //Close prev opened head on same lvl
    if (
      !$(this).hasClass("alh-opened") &&
      $(this).parent().parent().find(".alh-opened").length > 0
    ) {
      var prevOpened = $(this).parent().parent().find(".alh-opened")[0];
      openCloseAccordionHead(prevOpened);
    }

    openCloseAccordionHead(this);
  });

  function openCloseAccordionHead(clickedHead) {
    let expand = $(clickedHead).find(".accordion-list__head-expand span");
    if (expand.text() == "+") {
      expand.text("-");
    } else {
      expand.text("+");
    }

    if ($(clickedHead).hasClass("alh-opened")) {
      $(clickedHead).removeClass("alh-opened");
      // Проверяем если слайдер имеет переключатель списков и скрываем только активный.
      if ($(clickedHead).siblings(".alh-switcher").length) {
        var hideId = $(clickedHead)
          .siblings(".alh-switcher")
          .find(".alh-switcher__item-active")
          .attr("data-al-list-id");
        $(clickedHead)
          .siblings('.accordion-list__info[data-al-list="' + hideId + '"]')
          .slideUp("200");
        $(".alh-switcher").slideUp("200");
      } else {
        // иначе скрываем все что нашли
        $(clickedHead).siblings(".accordion-list__info").slideUp("200");
        $(".alh-switcher").slideUp("200");
      }
    } else {
      $(clickedHead).addClass("alh-opened");
      // Проверяем если слайдер имеет переключатель списков и показываем только активный.
      if ($(clickedHead).siblings(".alh-switcher").length) {
        var showId = $(clickedHead)
          .siblings(".alh-switcher")
          .find(".alh-switcher__item-active")
          .attr("data-al-list-id");
        $(clickedHead)
          .siblings('.accordion-list__info[data-al-list="' + showId + '"]')
          .slideDown("200");
        $(".alh-switcher").slideDown("200");
      } else {
        // иначе показываем все что нашли
        $(clickedHead).siblings(".accordion-list__info").slideDown("200");
        $(".alh-switcher").slideDown("200");
      }
    }
  }

  var accordionSubHead = $(
    ".accordion-list__info_item-subhead.open-mobile-modal"
  );
  accordionSubHead.on("click", function () {
    var asp = $(this).parent(".accordion-list__info_item");
    if (windowWidth < widthWideBreakpoint) {
      htmlbody.addClass("scrollOff");
      // открываем модал-окно
      $(this).on("click", function () {
        let modal = $("#modalDocList_" + $(this).attr("data-modal-id")).show();
        modal.find(".ui-modal__content").removeClass("ui-modal-closed");
        htmlbody.addClass("scrollOff");
        modal.show();
      });
      // закрываем модал-окно
      let modal = $("#modalDocList_" + $(this).attr("data-modal-id")).show();
      modal.find(".ui-modal__close, .ui-modal__bg").on("click", function () {
        modal.find(".ui-modal__content").addClass("ui-modal-closed");
        setTimeout(function () {
          modal.hide();
          htmlbody.removeClass("scrollOff");
        }, 600);
      });
    } else {
      if (asp.hasClass("al-subitem-opened")) {
        asp.removeClass("al-subitem-opened");
        asp.find(".accordion-list__info_item-details").slideUp("200");
      } else {
        asp.addClass("al-subitem-opened");
        asp.find(".accordion-list__info_item-details").slideDown("200");
      }
    }
  });

  if ($(".qna-questions")) {
    $(".accordion-list__item-main").bind("click", () => {
      let pattern = $(this).find(".accordion-list__header-expand-down");
      if (pattern.text() == "-") {
        pattern.text("+");
      } else {
        pattern.text("-");
      }
    });
  }

  /** Modal expand list */
  var modalDoclistExtendedItemTitle = $(".modal-doclist__extended-item_title");
  modalDoclistExtendedItemTitle.on("click", function () {
    let pattern = $(this).find("svg");
    pattern.toggleClass("modal__svg-rotated");
    $(this).siblings(".modal-doclist__extended-item_text").slideToggle();
  });

  /** Custom dropdown */
  var inputField = $(".fbm-step-item__input_field");
  inputField.on("click", function () {
    if ($(this).hasClass("dd-opened")) {
      $(this).removeClass("dd-opened");
    } else {
      $(this).addClass("dd-opened");
    }
  });

  /** Swipers */

  if ($("#needHelpSlider").length > 0) {
    var needHelpSlider = new Swiper("#needHelpSlider", {
      slidesPerView: "auto",
      // spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      // watchOverflow: true,
      breakpoints: {
        480: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
    needHelpSlider.update();
  }

  if ($("#mainPageSlider").length > 0) {
    var mainPageSlider = new Swiper("#mainPageSlider", {
      loop: true,
      initialSlide: sessionStorage.getItem("mainSliderNum")
        ? parseInt(sessionStorage.getItem("mainSliderNum"))
        : 0,
      autoplay: {
        delay: 20000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".top-splash-slider__pagination",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        prevEl: "#tssc-btn__prev",
        nextEl: "#tssc-btn__next",
      },
    });
    mainPageSlider.update();
    mainPageSlider.on("slideChange", function () {
      mainPageSliderslideChange();
      sessionStorage.setItem("mainSliderNum", mainPageSlider.realIndex);
    });
  }

  if ($("#programs-filter-slider").length > 0) {
    programsFilterSlider = new Swiper("#programs-filter-slider", {
      slidesPerView: "auto",
    });
  }

  if ($("#progButtonsSlider").length > 0) {
    var progButtonsSlider = new Swiper("#progButtonsSlider", {
      slidesPerView: "auto",
    });
    progButtonsSlider.update();
  }

  if ($("#progCardsSlider").length > 0) {
    progCardsSlider = new Swiper("#progCardsSlider", {
      slidesPerView: "auto",
      spaceBetween: 0,
      watchOverflow: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      //loop:true,
      breakpoints: {
        767: {
          // spaceBetween: 24,
        },
        768: {
          centeredSlides: false,
          centeredSlidesBounds: false,
          noSwiping: false,
          allowTouchMove: true,
        },
        1260: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
      navigation: {
        prevEl: "#progcardscontrolPrev",
        nextEl: "#progcardscontrolNext",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
    progCardsSlider.update();
  }

  if ($("#zaemCardsSlider").length > 0) {
    zaemCardsSlider = new Swiper("#zaemCardsSlider", {
      slidesPerView: "auto",
      spaceBetween: 0,
      watchOverflow: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      breakpoints: {
        768: {
          centeredSlides: false,
          centeredSlidesBounds: false,
          noSwiping: false,
          allowTouchMove: true,
        },
        1260: {
          noSwiping: true,
          allowTouchMove: true,
        },
      },
      navigation: {
        prevEl: "#progcardscontrolPrev",
        nextEl: "#progcardscontrolNext",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
    zaemCardsSlider.update();
  }

  if ($("#smartCardsSlider").length > 0) {
    var smartCardsSlider = new Swiper("#smartCardsSlider", {
      slidesPerView: "auto",
      spaceBetween: 0,
      watchOverflow: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      breakpoints: {
        767: {
          // spaceBetween: 24,
        },
        768: {
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        1259: {
          // spaceBetween: 24,
          slidesPerView: 3,
          slidesPerGroup: 2,
        },
      },
      navigation: {
        prevEl: "#smartcardscontrolPrev",
        nextEl: "#smartcardscontrolNext",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
    smartCardsSlider.update();
  }

  if ($("#prosBtnSlider").length > 0) {
    var prosBtnSlider = new Swiper("#prosBtnSlider", {
      slidesPerView: "auto",
      spaceBetween: 16,
      watchOverflow: true,
      breakpoints: {
        768: {
          noSwiping: true,
          allowTouchMove: false,
          spaceBetween: 32,
        },
        1259: {
          // spaceBetween: 24,
          // slidesPerView: 3,
        },
      },
    });
    prosBtnSlider.update();
  }

  if ($("#hestorySlider").length > 0) {
    var hestorySlider = new Swiper("#hestorySlider", {
      slidesPerView: "auto",
      spaceBetween: 0,
      watchOverflow: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        prevEl: "#hestoryControlPrev",
        nextEl: "#hestoryControlNext",
      },
      breakpoints: {
        767: {
          // spaceBetween: 24,
        },
        1024: {
          pagination: {},
          // spaceBetween: 24,
          // slidesPerView: 3,
        },
      },
    });
    hestorySlider.update();
  }

  var programsFilterBtn = $(".programs-filter-btn");
  programsFilterBtn.on("click", function () {
    if ($(this).hasClass("checkdchip")) {
      $(this).removeClass("checkdchip");
    } else {
      $(this).addClass("checkdchip");
    }
  });

  if ($("#clientCardsSlider").length > 0) {
    var clientCardsSlider = new Swiper("#clientCardsSlider", {
      slidesPerView: "auto",
      spaceBetween: 16,
      centeredSlides: true,
      // slidesPerView: 1.4,
      loop: false,
      breakpoints: {
        767: {
          spaceBetween: 24,
        },
      },
      navigation: {
        prevEl: "#clientcardscontrolPrev",
        nextEl: "#clientcardscontrolNext",
      },
    });
    clientCardsSlider.slideTo(1);
    clientCardsSlider.update();
  }
  if ($("#mainpageNewsSlider").length > 0) {
    var mainpageNewsSlider = new Swiper("#mainpageNewsSlider", {
      slidesPerView: "auto",
      spaceBetween: 0,
      slideActiveClass: "is-active",
      navigation: {
        prevEl: "#newsCardscontrolPrev",
        nextEl: "#newsCardscontrolNext",
      },
    });
    mainpageNewsSlider.update();
  }

  if ($(".quotes-slider").length > 0) {
    var quotesSlider = new Swiper(".quotes-slider", {
      slidesPerView: 1,
      loop: true,
      navigation: {
        prevEl: ".qsc-arrow__prev",
        nextEl: ".qsc-arrow__next",
      },
    });
    quotesSlider.update();
  }

  if ($("#iconsInfoSlider1").length > 0) {
    var iconsInfoSlider1 = new Swiper("#iconsInfoSlider1", {
      slidesPerView: "auto",
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      cssMode: true,
      // watchOverflow: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        480: {
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
    iconsInfoSlider1.update();
  }

  if ($("#iconsInfoSlider2").length > 0) {
    var iconsInfoSlider2 = new Swiper("#iconsInfoSlider2", {
      slidesPerView: "auto",
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      // watchOverflow: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        480: {
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
    iconsInfoSlider2.update();
  }
  if ($(".gps__main-slider").length > 0) {
    var gpsSlider = new Swiper(".gps__main-slider", {
      // Default parameters
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: ".gps__main-ctrl .swiper-button-next",
        prevEl: ".gps__main-ctrl .swiper-button-prev",
      },
      pagination: {
        el: $(".gps__main-ctrl .swiper-pagination"),
        type: "fraction",
        renderFraction: function (currentClass, totalClass, index, total) {
          return (
            '<span class="' +
            currentClass +
            '">' +
            index +
            " </span>" +
            " / " +
            '<span class="' +
            totalClass +
            '">' +
            total +
            " </span>"
          );
        },
      },
    });
    gpsSlider.update();
  }

  // if ($('.programs-swiper-container').length > 0) {
  //     var screenWidth = $(window).width();
  //     var mobileSreenWidth = 789;
  //     if (screenWidth <= mobileSreenWidth) {
  //         $('.swiper-wrapper').removeClass('programs-swiper-wrapper');
  //     }
  //     accuProgramSwiper = new Swiper('.programs-swiper-container', {
  //         slidesPerView: 'auto',
  //         watchOverflow: true,
  //         centeredSlides: true,
  //         centeredSlidesBounds: true,
  //         cssMode: true,
  //         breakpoints: {
  //             768: {
  //                 centeredSlides: false,
  //                 centeredSlidesBounds: false,
  //             },
  //             1280: {
  //                 noSwiping: true,
  //                 allowTouchMove: false,
  //             },
  //         },
  //     });
  //     accuProgramSwiper.update();
  // }

  if ($(".programs-swiper-container").length > 0) {
    const breakpoint = window.matchMedia("(min-width:1280px)");

    let accuProgramSwiper;

    const breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (accuProgramSwiper !== undefined)
          accuProgramSwiper.destroy(true, true);

        // or/and do nothing
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      accuProgramSwiper = new Swiper(".programs-swiper-container", {
        slidesPerView: "auto",
        watchOverflow: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          768: {
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
          // 1280: {
          //   noSwiping: true,
          //   allowTouchMove: false,
          // },
        },
      });
      accuProgramSwiper.update();
    };

    breakpoint.addListener(breakpointChecker); // kickstart
    breakpointChecker();
  }

  if ($(".programs-swiper-container-multy").length > 0) {
    console.log("----------accuProgramSwiperMulty-------");

    const breakpoint = window.matchMedia("(min-width:1280px)");

    let accuProgramSwiperMulty;

    const breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (accuProgramSwiperMulty !== undefined)
          accuProgramSwiperMulty.destroy(true, true);

        // or/and do nothing
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      accuProgramSwiperMulty = new Swiper(".programs-swiper-container-multy", {
        slidesPerView: "auto",
        watchOverflow: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          768: {
            slidesPerView: 1,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
        },
      });
      console.log(accuProgramSwiperMulty);
      if (accuProgramSwiper instanceof Swiper) {
        accuProgramSwiper.update();
      }
    };

    breakpoint.addListener(breakpointChecker); // kickstart
    breakpointChecker();
  }

  if ($(".accu-swiper-container").length > 0) {
    var accuCardsSwiper = new Swiper(".accu-swiper-container", {
      slidesPerView: "auto",
      breakpoints: {
        1400: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });
    accuCardsSwiper.update();
  }
  if ($(".chart-swiper").length > 0) {
    var chartSwiper = new Swiper(".chart-swiper", {
      slidesPerView: "auto",
      watchOverflow: true,
      breakpoints: {
        768: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });
    chartSwiper.update();
  }
  if ($(".faq-switcher-swiper-container").length > 0) {
    var faqSwitcherSwiper = new Swiper(".faq-switcher-swiper-container", {
      slidesPerView: "auto",
      watchOverflow: true,
    });
    faqSwitcherSwiper.update();
  }

  if ($(".how-apply-swiper-container").length > 0) {
    var howApplySwitcherSwiper = new Swiper(".how-apply-swiper-container", {
      slidesPerView: "auto",
      watchOverflow: true,
      spaceBetween: 16,
      breakpoints: {
        1100: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });
    howApplySwitcherSwiper.update();
  }

  if ($(".option-swiper-container").length > 0) {
    var optionSwitcherSwiper = new Swiper(".option-swiper-container", {
      slidesPerView: "auto",
      watchOverflow: true,
      spaceBetween: 16,
      breakpoints: {
        1100: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });
    optionSwitcherSwiper.update();
  }

  if ($(".docs-swiper-container-1").length > 0) {
    var docsSwitcherSwiper1 = new Swiper(".docs-swiper-container-1", {
      slidesPerView: "auto",
      watchOverflow: true,
      spaceBetween: 16,
      breakpoints: {
        // 1024: {
        1260: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });
    docsSwitcherSwiper1.update();
  }
  if ($(".docs-swiper-container-2").length > 0) {
    var docsSwitcherSwiper2 = new Swiper(".docs-swiper-container-2", {
      slidesPerView: "auto",
      watchOverflow: true,
      spaceBetween: 16,
      breakpoints: {
        // 1024: {
        1260: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });
    docsSwitcherSwiper2.update();
  }
  if ($(".docs-swiper-container-3").length > 0) {
    var docsSwitcherSwiper3 = new Swiper(".docs-swiper-container-3", {
      slidesPerView: "auto",
      watchOverflow: true,
      spaceBetween: 16,
      breakpoints: {
        // 1024: {
        1260: {
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });
    docsSwitcherSwiper3.update();
  }

  if ($("#medsliderphone").length > 0) {
    var medSliderPhone = new Swiper("#medsliderphone", {
      slidesPerView: 1,
      navigation: {
        prevEl: ".medslider-btn__prev",
        nextEl: ".medslider-btn__next",
      },
      pagination: {
        el: "#medsliderpagination",
        type: "bullets",
      },
    });
    medSliderPhone.update();
  }

  if ($(".clients-reviews").length > 0) {
    var clientsReviewsSlider = new Swiper(".clients-reviews", {
      slidesPerView: "auto",
      spaceBetween: 16,
      breakpoints: {
        1260: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
      pagination: {
        el: "#clients-swiper-pagination",
        type: "bullets",
      },
      navigation: {
        prevEl: "#reviewsSliderControlPrev",
        nextEl: "#reviewsSliderControlNext",
      },
    });
    clientsReviewsSlider.update();
  }

  function slidersRecalc() {
    var baseContainer = $(".container")[0],
      baseContainerLeftOffset = baseContainer.offsetLeft + 15;

    setSlidesOffset(programsFilterSlider, baseContainerLeftOffset);

    if ($(window).width() < 1260) {
      setSlidesOffset(clientCardsSlider, baseContainerLeftOffset);
      setSlidesOffset(progCardsSlider, baseContainerLeftOffset - 8);
      setSlidesOffset(zaemCardsSlider, baseContainerLeftOffset - 8);
      setSlidesOffset(smartCardsSlider, baseContainerLeftOffset - 8);
      setSlidesOffset(prosBtnSlider, baseContainerLeftOffset);
      setSlidesOffset(hestorySlider, baseContainerLeftOffset - 8);
      setSlidesOffset(mainpageNewsSlider, baseContainerLeftOffset - 8);
      setSlidesOffset(accuProgramSwiper, baseContainerLeftOffset - 12);
      setSlidesOffset(accuCardsSwiper, baseContainerLeftOffset + 12);
      setSlidesOffset(clientsReviewsSlider, baseContainerLeftOffset);
      setSlidesOffset(howApplySwitcherSwiper, baseContainerLeftOffset);
      setSlidesOffset(optionSwitcherSwiper, baseContainerLeftOffset);
      setSlidesOffset(docsSwitcherSwiper1, baseContainerLeftOffset);
      setSlidesOffset(docsSwitcherSwiper2, baseContainerLeftOffset);
      setSlidesOffset(docsSwitcherSwiper3, baseContainerLeftOffset);
    } else {
      setSlidesOffset(clientCardsSlider, 0);
      setSlidesOffset(progCardsSlider, 0);
      setSlidesOffset(zaemCardsSlider, 0);
      setSlidesOffset(smartCardsSlider, 0);
      setSlidesOffset(prosBtnSlider, 0);
      setSlidesOffset(hestorySlider, 0);
      setSlidesOffset(mainpageNewsSlider, 0);
      setSlidesOffset(accuProgramSwiper, 0);
      setSlidesOffset(accuCardsSwiper, 0);
      setSlidesOffset(chartSwiper, 0);
      setSlidesOffset(clientsReviewsSlider, 0);
      setSlidesOffset(howApplySwitcherSwiper, 0);
      setSlidesOffset(optionSwitcherSwiper, 0);
      setSlidesOffset(docsSwitcherSwiper1, 0);
      setSlidesOffset(docsSwitcherSwiper2, 0);
      setSlidesOffset(docsSwitcherSwiper3, 0);
    }

    if ($(window).width() < 768) {
      // setSlidesOffset(chartSwiper, baseContainerLeftOffset);
      setSlidesOffset(chartSwiper, baseContainerLeftOffset + 12);
    } else {
      setSlidesOffset(chartSwiper, 0);
    }

    updateSwiper(programsFilterSlider);
    updateSwiper(progCardsSlider);
    updateSwiper(zaemCardsSlider);
    updateSwiper(smartCardsSlider);
    updateSwiper(prosBtnSlider);
    updateSwiper(hestorySlider);
    updateSwiper(clientCardsSlider);
    updateSwiper(mainpageNewsSlider);
    updateSwiper(accuProgramSwiper);
    updateSwiper(accuCardsSwiper);
    updateSwiper(chartSwiper);
    updateSwiper(faqSwitcherSwiper);
    updateSwiper(clientsReviewsSlider);
    updateSwiper(howApplySwitcherSwiper);
    updateSwiper(optionSwitcherSwiper);
    updateSwiper(docsSwitcherSwiper1);
    updateSwiper(docsSwitcherSwiper2);
    updateSwiper(docsSwitcherSwiper3);
  }

  onSwiperResize(programsFilterSlider);
  onSwiperResize(progCardsSlider);
  onSwiperResize(zaemCardsSlider);
  onSwiperResize(smartCardsSlider);
  onSwiperResize(prosBtnSlider);
  onSwiperResize(hestorySlider);
  onSwiperResize(clientCardsSlider);
  onSwiperResize(mainpageNewsSlider);
  onSwiperResize(accuProgramSwiper);
  onSwiperResize(accuCardsSwiper);
  onSwiperResize(chartSwiper);
  onSwiperResize(faqSwitcherSwiper);
  onSwiperResize(clientsReviewsSlider);
  onSwiperResize(howApplySwitcherSwiper);
  onSwiperResize(optionSwitcherSwiper);
  onSwiperResize(docsSwitcherSwiper1);
  onSwiperResize(docsSwitcherSwiper2);
  onSwiperResize(docsSwitcherSwiper3);

  /*helper  func for swiper */
  function setSlidesOffset(slider, offset) {
    return false;
    if (slider) {
      slider.params.slidesOffsetBefore = offset;
      slider.params.slidesOffsetAfter = offset;
    }
  }

  function updateSwiper(slider) {
    return false;
    if (slider) {
      slider.update();
    }
  }

  function resizeElements() {
    return false;
    slidersRecalc();
    stickyBarOffset =
      windowWidth > widthNarrowBreakpoint
        ? 5
        : windowWidth > widthAverageBreakpoint
          ? 30
          : windowWidth > widthWideBreakpoint
            ? 20
            : 2;
    return (windowWidth = screen.width), stickyBarOffset;
  }

  function onSwiperResize(slider) {
    return false;
    if (slider) {
      slider.on("resize orientationchange", function () {
        resizeElements();
      });
    }
  }

  $window.on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeElements, 100);
  });

  $window.on("resize orientationchange", function () {
    setTimeout(function () {
      resizeElements();
    }, 300);
  });

  resizeElements();

  //contacts
  var showAllSteps = $(".gps-ctrl__show-all"),
    hideAllSteps = $(".gps-ctrl__hide-all"),
    allSteps = $(".gps__main-all"),
    pedestrian = $(".gps__main-pers"),
    auto = $(".gps__main-auto"),
    autoTrigger = $(".gps-choose__auto-trigger"),
    pedTrigger = $(".gps-choose__ped-trigger");
  //toggle auto or pedestrian
  auto.hide();
  pedTrigger.on("click", function () {
    autoTrigger.find("input").prop("checked", false);
    pedTrigger.find("input").prop("checked", true);
    auto.hide();
    pedestrian.slideDown();
  });
  autoTrigger.on("click", function () {
    pedTrigger.find("input").prop("checked", false);
    autoTrigger.find("input").prop("checked", true);
    auto.slideDown();
    pedestrian.hide();
  });
  //steps for pedestrian
  allSteps.hide();
  showAllSteps.on("click", function (e) {
    e.preventDefault();
    //hide
    $(".gps__main-slider, .gps__main-ctrl").hide();
    //show
    allSteps.slideDown();
  });
  hideAllSteps.on("click", function (e) {
    e.preventDefault();
    //show
    $(".gps__main-slider, .gps__main-ctrl").show();
    //hide
    allSteps.slideUp();
  });
  //    console.log(0);
  /** contract payment selector */
  var doubleSelectItem = $(".spo-item"),
    spoPanel = $(".spo-panel");
  doubleSelectItem.on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();

    if (screen.width > widthAverageBreakpoint) {
      console.log("desktop click");

      doubleSelectItem.removeClass("spo-item__active");
      $(this).addClass("spo-item__active");
      spoPanel.hide();
      var dsiClikedIndex = $(this).data("panel");
      if (dsiClikedIndex === "spo-panel-1") {
        $(".spo-panel-1").show();
      } else {
        $(".spo-panel-2").show();
      }
    } else {
      console.log("mobile click");

      if ($(this).siblings(".spo-dropdown").css("display") === "none") {
        $(this).find("svg").css("transform", "rotate(180deg)");
        $(this).siblings(".spo-dropdown").show();
      } else {
        $(this).find("svg").css("transform", "rotate(0deg)");
        $(this).siblings(".spo-dropdown").hide();
      }
    }
  });

  var optionSwitcherItem = $(".option-switcher__item"),
    optIndexTab = $(".opt-index-tab"),
    ConsumerProsTab = $(".pros-tab"),
    optIndexFeatures = $(".opt-index-features"),
    optIndexTable = $(".opt-index-table"),
    consumerIndexProg = $(".consumer-index-program"),
    consumerIndexParam = $(".consumer-index-parameters"),
    consumerIndexIns = $(".consumer-index-insurance");

  optionSwitcherItem.on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    var dataTab = $(this).data("switcher");
    optIndexTab.hide();
    var consumerDataTab = $(this).data("switcher");
    ConsumerProsTab.hide();
    if ($(this).hasClass("option-switcher__item--active")) {
      /*do nothing*/
    } else {
      optionSwitcherItem.removeClass("option-switcher__item--active");
      $(this).addClass("option-switcher__item--active");
    }
    if (dataTab === "tab_130") {
      optIndexFeatures.show();
    } else {
      optIndexTable.show();
    }
    if (consumerDataTab === "tab1") {
      consumerIndexProg.show();
    } else if (consumerDataTab === "tab2") {
      consumerIndexParam.show();
    } else {
      consumerIndexIns.show();
    }
  });

  var faqSwitcherButton = $(".faq-switcher__button"),
    faqTab = $(".faq-tab"),
    faqIndexFirst = $(".faq-index-first"),
    faqIndexSecond = $(".faq-index-second");

  faqSwitcherButton.on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    var faqDataTab = $(this).data("faq-switcher");
    faqTab.hide();
    if ($(this).hasClass("faq-switcher__button_active")) {
      /*do nothing*/
    } else {
      faqSwitcherButton.removeClass("faq-switcher__button_active");
      $(this).addClass("faq-switcher__button_active");
    }
    if (faqDataTab === "tab1") {
      faqIndexFirst.show();
    } else {
      faqIndexSecond.show();
    }
  });

  var accuFaqSwitcherButton = $(".accu-faq-switcher__button"),
    accuFaqTab = $(".faq-tab"),
    accuFaqIndexFirst = $(".accu-faq-index-first"),
    accuFaqIndexSecond = $(".accu-faq-index-second"),
    accuFaqIndexThree = $(".accu-faq-index-three"),
    accuFaqIndexFour = $(".accu-faq-index-four"),
    accuFaqIndexFive = $(".accu-faq-index-five"),
    accuFaqIndexSix = $(".accu-faq-index-six"),
    accuFaqIndexSeven = $(".accu-faq-index-seven"),
    allQuestionsBtn = $(".faq-all-questions"),
    allQuestions = $(".all-questions");

  accuFaqSwitcherButton.on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    var accuFaqDataTab = $(this).data("accu-faq-switcher");
    accuFaqTab.hide();
    allQuestions.hide();
    allQuestionsBtn.removeClass("togled");
    if ($(this).hasClass("accu-faq-switcher__button_active")) {
      /*do nothing*/
    } else {
      accuFaqSwitcherButton.removeClass("accu-faq-switcher__button_active");
      $(this).addClass("accu-faq-switcher__button_active");
    }
    if (accuFaqDataTab === "tab1") {
      accuFaqIndexFirst.show();
    } else if (accuFaqDataTab === "tab2") {
      accuFaqIndexSecond.show();
    } else if (accuFaqDataTab === "tab3") {
      accuFaqIndexThree.show();
    } else if (accuFaqDataTab === "tab4") {
      accuFaqIndexFour.show();
    } else if (accuFaqDataTab === "tab5") {
      accuFaqIndexFive.show();
    } else if (accuFaqDataTab === "tab6") {
      accuFaqIndexSix.show();
    } else if (accuFaqDataTab === "tab7") {
      accuFaqIndexSeven.show();
    }
  });

  var docsSwitcherButton = $(".docs-switcher__button"),
    docsTab = $(".docs-tab"),
    docsIndexFirst = $(".docs-index-first"),
    docsIndexSecond = $(".docs-index-second"),
    docsIndexThree = $(".docs-index-three");

  docsSwitcherButton.on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    var docsDataTab = $(this).data("docs-switcher");
    docsTab.hide();
    if ($(this).hasClass("docs-switcher__button_active")) {
      /*do nothing*/
    } else {
      docsSwitcherButton.removeClass("docs-switcher__button_active");
      $(this).addClass("docs-switcher__button_active");
    }
    if (docsDataTab === "tab1") {
      docsIndexFirst.css("display", "block");
    } else if (docsDataTab === "tab2") {
      docsIndexSecond.css("display", "block");
    } else {
      docsIndexThree.css("display", "block");
    }

    updateSwiper(docsSwitcherSwiper1);
    updateSwiper(docsSwitcherSwiper2);
    updateSwiper(docsSwitcherSwiper3);
  });

  $(".spo-dd-item").on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();

    // Поворачиваем свгшки
    $(doubleSelectItem)
      .parent()
      .find(".spo-item")
      .each(function () {
        $(this).find("svg").css("transform", "rotate(0deg)");
      });

    if ($(this).hasClass("spo-dd-item__active")) {
      $(this).parent().hide();
    } else {
      $(".spo-dd-item").removeClass("spo-dd-item__active");
      $(this).addClass("spo-dd-item__active");

      // Переключаем десктопную ссылку тоже
      var desktopActiveLnk = $(doubleSelectItem)
        .parent()
        .find(".spo-item__active");
      $(desktopActiveLnk).siblings(".spo-item").addClass("spo-item__active");
      $(desktopActiveLnk).removeClass("spo-item__active");

      spoPanel.hide();
      var dsiClikedIndex = $(this).data("panel");
      if (dsiClikedIndex === "spo-panel-1") {
        $(".spo-panel-1").show();
      } else {
        $(".spo-panel-2").show();
      }

      $(this).parent().hide();
    }
  });
  /*
     $('.spo-item, .spo-dropdown').on('mouseenter', function () {
     $(this).siblings('.spo-dropdown').show();
     });
     $('.spo-item, .spo-dropdown').on('mouseleave', function () {
     setTimeout(function (_this) {
     $(_this).siblings('.spo-dropdown').hide()
     }, 1000, this);
     });
     */

  $("#scroll-to-feedback-frm").click(function (e) {
    e.preventDefault();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(".contacts-feedback").offset().top,
      },
      500
    );
  });

  $("#scroll-to-ins-case-doc-list, #scroll-to-ins-case-doc-list-1").click(
    function (e) {
      e.preventDefault();
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#ins-case-doc-list").offset().top - 20,
        },
        500
      );
    }
  );

  var needCallTrigger = $(".bii-call"),
    needCallMobile = $("#needCallMob"),
    needCall = $("#needCall");

  modalCloseBtn.on("click", function () {
    needCall.find(".ui-modal__content").addClass("ui-modal-closed");
    needCallMobile.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        needCall.hide();
        needCallMobile.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  modalCloseBG.on("click", function () {
    needCall.find(".ui-modal__content").addClass("ui-modal-closed");
    needCallMobile.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        needCall.hide();
        needCallMobile.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  needCallTrigger.on("click", function (e) {
    e.preventDefault();
    needCallMobile.find(".ui-modal__content").removeClass("ui-modal-closed");
    needCall.find(".ui-modal__content").removeClass("ui-modal-closed");
    htmlbody.addClass("scrollOff");
    if (windowWidth < widthWideBreakpoint) {
      needCallMobile.show();
    } else {
      needCall.show();
    }
  });

  //auto resize height for textarea
  var resizeableTextarea = $(".textarea_resizeable");
  if (resizeableTextarea.length) {
    function resizeTextarea() {
      resizeableTextarea.css({ height: "auto" });
      resizeableTextarea.css({
        height:
          document.querySelector(".textarea_resizeable").scrollHeight + "px",
      });
    }

    function delayedResizeTextarea() {
      window.setTimeout(resizeTextarea, 0);
    }

    resizeableTextarea.on("change", resizeTextarea);
    resizeableTextarea.bind("cut paste drop keydown", delayedResizeTextarea);
    resizeTextarea();
  }
  // sticky bar for faq page
  var stickyBar = $(".sticky__init");
  var stickyBarOffset =
    windowWidth > widthNarrowBreakpoint
      ? 0
      : windowWidth > widthAverageBreakpoint
        ? 30
        : windowWidth > widthWideBreakpoint
          ? 20
          : 20;
  if (stickyBar.length) {
    $(document).on("scroll", function () {
      if (stickyBar.offset().top > window.scrollY) {
        stickyBar.css({ position: "absolute", top: "0", bottom: "inherit" });
      }
      if (stickyBar.offset().top < window.scrollY) {
        stickyBar.css({ position: "fixed", top: "8px", bottom: "inherit" });
      }
      if (
        stickyBar.offset().top >
        $(".faq").offset().top +
        $(".faq").height() -
        stickyBar.height() -
        stickyBarOffset
      ) {
        stickyBar.css({ bottom: "0px", position: "absolute", top: "inherit" });
      }
      return stickyBarOffset;
    });
  }

  // Start user quotes slider for news page
  var userQuoteSlider = new Swiper(".user-quote__container", {
    // Optional parameters
    loop: false,
    // Navigation arrows
    slideActiveClass: "is-active",
    navigation: {
      disabledClass: "is-disabled",
      nextEl: ".user-quote__btn--next",
      prevEl: ".user-quote__btn--left",
    },
  });
  document.addEventListener("click", function (e) {
    let elem = e.target; // get target element
    if (!elem.classList.contains("user-quote__btn--disabled")) {
      if (elem.classList.contains("user-quote__btn--left")) {
        userQuoteSlider.slidePrev();
      } else if (elem.classList.contains("user-quote__btn--right")) {
        userQuoteSlider.slideNext();
      }
    }
  });
  // END user quotes slider for news page

  // Start news slider for news detail page
  var newsItemSlider = new Swiper(".news-page__slider-container", {
    // Optional parameters
    slidesPerView: "auto",
    parallax: true,
    loop: true,
    speed: 600,
    spaceBetween: 0,
    // Navigation arrows
    slideActiveClass: "is-active",
    navigation: {
      nextEl: ".news-page__slider-btn--next",
      prevEl: ".news-page__slider-btn--left",
    },
    pagination: {
      el: ".news-page__slider-pagination",
      clickable: true,
    },
    breakpoints: {
      1260: {
        slidesPerView: "3",
      },
      768: {
        slidesPerView: "1",
      },
    },
  });
  // END news slider for news detail page

  // Start blog popup
  var blogRead = $("#blogRead");

  $(document).on("click", ".ui-modal__close", function () {
    blogRead.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        blogRead.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  $(document).on("click", ".ui-modal__bg", function () {
    blogRead.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        blogRead.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  $(document).on("click", ".blog-page__item", function (e) {
    e.preventDefault();
    blogRead.find(".ui-modal__content").removeClass("ui-modal-closed");
    htmlbody.addClass("scrollOff");
    blogRead.show();
  });
  //END blog popup

  // Start career accordion
  $(".ui-accordion__head").click(function () {
    var dropDown = $(this)
      .closest(".ui-accordion__card")
      .find(".ui-accordion__body"),
      card = $(this).parent();
    $(".ui-accordion__body").not(dropDown).slideUp("fast");
    if (card.hasClass("active")) {
      card.removeClass("active");
    } else {
      $(".ui-accordion__card.active").removeClass("active");
      card.addClass("active");
    }
    dropDown.stop(false, true).slideToggle("fast");
  });
  // END career accordion

  // Start career swiper
  var careerSlider = new Swiper(".career-page__slider .swiper-container", {
    pagination: {
      el: ".career-page__slider  .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".career-page__slider  .swiper-button-next",
      prevEl: ".career-page__slider  .swiper-button-prev",
    },
    slidesPerView: 1.1,
    breakpoints: {
      767: {
        slidesPerView: 1,
      },
    },
  });
  // END career swiper

  // Start review slider
  var reviewsSlider = new Swiper(".review-page__another .swiper-container", {
    pagination: {
      el: ".review-page__another  .swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".review-page__another  .swiper-button-next",
      prevEl: ".review-page__another  .swiper-button-prev",
    },
    slidesPerView: "auto",
    spaceBetween: 24,
    breakpoints: {
      1260: {
        slidesPerView: 2,
      },
    },
  });
  // END review slider

  //Start about popup
  var aboutRead = $(".about-modal--box");
  var aboutReadCount = aboutRead.length;

  if ($(".about-page")) {
    $(".about-modal--box .position--all").text(aboutReadCount);
  }

  $(document).on("click", ".ui-modal__close", function () {
    aboutRead.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        aboutRead.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  $(document).on("click", ".ui-modal__bg", function () {
    aboutRead.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        aboutRead.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  $(document).on("click", ".call--text-modal", function (e) {
    e.preventDefault();

    var thisNumber = $(this).next(".about-modal--box").data("number");

    $(this)
      .next(".about-modal--box")
      .find(".position--current")
      .text(thisNumber);
    $(this)
      .next(".about-modal--box")
      .find(".position--all")
      .text(aboutReadCount);
    $(this)
      .next(".about-modal--box")
      .find(".ui-modal__content")
      .removeClass("ui-modal-closed");
    htmlbody.addClass("scrollOff");
    $(this).next(".about-modal--box").show();
  });
  $(".about-modal--box .arrow-next").on("click", function () {
    var modalNumber = $(this).closest(".about-modal--box").data("number");

    if (modalNumber + 1 < aboutReadCount) {
      aboutRead.find(".ui-modal__content").addClass("ui-modal-closed");
      aboutRead.hide();

      $(this)
        .closest(".people-row_item")
        .next()
        .find(".position--current")
        .text(modalNumber + 1);
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".about-modal--box")
        .show();
    } else if (modalNumber + 1 == aboutReadCount) {
      $(this)
        .closest(".people-row_item")
        .next(".people-row_item")
        .find(".arrow-next")
        .addClass("disabled");

      aboutRead.find(".ui-modal__content").addClass("ui-modal-closed");
      aboutRead.hide();

      $(this)
        .closest(".people-row_item")
        .next()
        .find(".position--current")
        .text(modalNumber + 1);
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".about-modal--box")
        .show();
    } else {
    }
  });
  $(".about-modal--box .arrow-prev").on("click", function () {
    var modalNumber = $(this).closest(".about-modal--box").data("number");

    if (
      modalNumber - 1 < aboutReadCount &&
      modalNumber - 1 != 1 &&
      modalNumber - 1 != 0
    ) {
      aboutRead.find(".ui-modal__content").addClass("ui-modal-closed");
      aboutRead.hide();

      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".position--current")
        .text(modalNumber - 1);
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".about-modal--box")
        .show();
    } else if (modalNumber - 1 == 1) {
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".arrow-prev")
        .addClass("disabled");

      aboutRead.find(".ui-modal__content").addClass("ui-modal-closed");
      aboutRead.hide();

      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".position--current")
        .text(modalNumber - 1);
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".about-modal--box")
        .show();
    } else {
    }
  });
  //END about popup

  // Start years slider

  // END years slider

  // Edit block
  $(".edited-text--block .filter-btn").on("click", function () {
    $(this).toggleClass("active");
  });
  /*
     var aboutYearItemSlider = new Swiper('.about-page__years .swiper-container', {
     // Optional parameters
     slidesPerView: '7',
     slideToClickedSlide: '1',
     loop: false,
     spaceBetween: 0,
     centeredSlides: true,
     // Navigation arrows
     slideActiveClass: 'is-active',
     navigation: {
     nextEl: '.about-page__years .swiper-button-next',
     prevEl: '.about-page__years .swiper-button-prev'
     }
     });
     */
  // END edit block

  //Start career sticky nav
  var careerNav = $(".desktop-nav");
  var careerNavMobile = $(".career-filter_mobile");
  if (careerNav.length) {
    $(document).on("scroll", function () {
      if ($(this).scrollTop() >= $(window).height() + careerNav.height()) {
        if (!careerNav.hasClass("sticky-nav")) {
          careerNav.css("display", "none").addClass("sticky-nav").fadeIn(500);
        }
      } else {
        careerNav.removeClass("sticky-nav");
      }
    });
  }
  if (careerNavMobile.length) {
    $(document).on("scroll", function () {
      if (
        $(this).scrollTop() >=
        $(window).height() - careerNavMobile.height()
      ) {
        careerNavMobile.addClass("sticky-nav_mobile");
      } else {
        careerNavMobile.removeClass("sticky-nav_mobile");
      }
    });
  }
  //END career sticky nav

  // Start career mobile filter
  $(".career-filter_mobile .head-block").on("click", function () {
    $(this).next(".body-block").slideToggle();
  });
  $(".career-filter_mobile .btn-line").on("click", function () {
    var currentText = $(this).find("span").text();

    if (!$(this).hasClass("active")) {
      $(".btn-line").removeClass("active");
      $(this).addClass("active");
      $(".career-filter_mobile .head-block").find("span").text(currentText);
      $(".career-filter_mobile .body-block").slideToggle();
    } else {
      $(".career-filter_mobile .body-block").slideToggle();
    }
  });
  // END career mobile filter

  //Start career navigation
  var positions = [],
    currentActive = null,
    links = $(".career-filter a");
  $(".career-nav").each(function () {
    positions.push({
      top: $(this).position().top - 150,
      a: links.filter('[href="#' + $(this).attr("id") + '"]'),
    });
  });
  positions = positions.reverse();
  $(window).on("scroll", function () {
    for (var winTop = $(window).scrollTop(), i = 0; i < positions.length; i++)
      if (positions[i].top < winTop) {
        currentActive !== i &&
          ((currentActive = i),
            links.removeClass("active"),
            positions[i].a.addClass("active"));
        break;
      }
  });
  var positions2 = [],
    currentActive2 = null,
    links2 = $(".career-filter_mobile .body-block a");
  $(".career-nav").each(function () {
    positions2.push({
      top: $(this).position().top - 50,
      a: links2.filter('[href="#' + $(this).attr("id") + '"]'),
    });
  });
  positions2 = positions2.reverse();
  $(window).on("scroll", function () {
    for (var winTop = $(window).scrollTop(), i = 0; i < positions2.length; i++)
      if (positions2[i].top < winTop) {
        currentActive2 !== i &&
          ((currentActive2 = i),
            links2.removeClass("active"),
            positions2[i].a.addClass("active"));
        break;
      }
    var currentBlock = $(".career-filter_mobile .active span").text();
    $(".career-filter_mobile .head-block span").text(currentBlock);
  });
  //END career navigation

  //Start career popup
  var careerRead = $(".career-modal--box");
  var careerReadCount = careerRead.length;

  if ($(".career-page")) {
    $(".career-modal--box .position--all").text(careerReadCount);
  }

  $(document).on("click", ".ui-modal__close", function () {
    careerRead.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        careerRead.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  $(document).on("click", ".ui-modal__bg", function () {
    careerRead.find(".ui-modal__content").addClass("ui-modal-closed");
    setTimeout(
      function () {
        careerRead.hide();
        htmlbody.removeClass("scrollOff");
      },
      windowWidth < widthWideBreakpoint ? 800 : 400
    );
  });
  $(document).on("click", ".call--video-modal", function (e) {
    e.preventDefault();

    var thisNumber = $(this).next(".career-modal--box").data("number");

    if (thisNumber == 1) {
      $(this)
        .next(".career-modal--box")
        .find(".arrow-prev")
        .addClass("disabled");
    }
    if (thisNumber == careerReadCount) {
      $(this)
        .next(".career-modal--box")
        .find(".arrow-next")
        .addClass("disabled");
    }

    $(this)
      .next(".career-modal--box")
      .find(".position--current")
      .text(thisNumber);
    $(this)
      .next(".career-modal--box")
      .find(".ui-modal__content")
      .removeClass("ui-modal-closed");
    htmlbody.addClass("scrollOff");
    $(this).next(".career-modal--box").show();
  });
  $(".career-modal--box .arrow-next").on("click", function () {
    var modalNumber = $(this).closest(".career-modal--box").data("number");

    if (modalNumber + 1 < careerReadCount) {
      careerRead.find(".ui-modal__content").addClass("ui-modal-closed");
      careerRead.hide();

      $(this)
        .closest(".people-row_item")
        .next()
        .find(".position--current")
        .text(modalNumber + 1);
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".career-modal--box")
        .show();
    } else if (modalNumber + 1 == careerReadCount) {
      $(this)
        .closest(".people-row_item")
        .next(".people-row_item")
        .find(".arrow-next")
        .addClass("disabled");

      careerRead.find(".ui-modal__content").addClass("ui-modal-closed");
      careerRead.hide();

      $(this)
        .closest(".people-row_item")
        .next()
        .find(".position--current")
        .text(modalNumber + 1);
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .next()
        .find(".career-modal--box")
        .show();
    } else {
    }
  });
  $(".career-modal--box .arrow-prev").on("click", function () {
    var modalNumber = $(this).closest(".career-modal--box").data("number");

    if (
      modalNumber - 1 < careerReadCount &&
      modalNumber - 1 != 1 &&
      modalNumber - 1 != 0
    ) {
      careerRead.find(".ui-modal__content").addClass("ui-modal-closed");
      careerRead.hide();

      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".position--current")
        .text(modalNumber - 1);
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".career-modal--box")
        .show();
    } else if (modalNumber - 1 == 1) {
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".arrow-prev")
        .addClass("disabled");

      careerRead.find(".ui-modal__content").addClass("ui-modal-closed");
      careerRead.hide();

      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".position--current")
        .text(modalNumber - 1);
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".ui-modal__content")
        .removeClass("ui-modal-closed");
      $(this)
        .closest(".people-row_item")
        .prev(".people-row_item")
        .find(".career-modal--box")
        .show();
    } else {
    }
  });
  //END career popup

  // Start blog mobile filter
  $(".blog-filter_mobile .head-block").on("click", function () {
    $(this).next(".body-block").slideToggle();
  });
  $(".blog-filter_mobile .btn-line").on("click", function () {
    var currentText = $(this).find("span").text();

    if (!$(this).hasClass("active")) {
      $(".btn-line").removeClass("active");
      $(this).addClass("active");
      $(".blog-filter_mobile .head-block").find("span").text(currentText);
      $(".blog-filter_mobile .body-block").slideToggle();
    } else {
      $(".blog-filter_mobile .body-block").slideToggle();
    }
  });
  // END blog mobile filter

  // Accumulative life
  let accuBtn = $(".programs-archive-btn");
  let accuSlideBtn = $(".program-archive-slide .pas");
  let accuProgs = $(".program-archive");
  let accuQuestionBtn = $(".faq-all-questions");
  let accuQuestion = $(".all-questions");

  accuBtn.on("click", function () {
    accuProgs.toggle();
    $(this).toggleClass("togled");
    if ($(this).hasClass("togled")) {
      $(this).find("svg").css("transform", "rotate(180deg)");
    } else {
      $(this).find("svg").css("transform", "rotate(0deg)");
    }
  });
  accuQuestionBtn.on("click", function () {
    accuQuestion.toggle();
    $(this).toggleClass("togled");
  });
  accuSlideBtn.on("click", function () {
    accuProgs.toggle();
    accuProgramSwiper.update();
    $(".pas-icon").toggleClass("active");
  });
  // END accumulative life
})(jQuery);
